import {
  AbstractComparatorApiService,
  AddressApiSuccessResponse,
  AddressData,
  basicHomeIProduct,
  basicHomeProduct,
  basicHomeSupplier,
  CalculateParameters,
  Comparison,
  CustormerBenefitItem,
  FeaturesEdge,
  getUspsBySellingPointsByOrderType,
  IComparatorApiServiceParameters,
  IGraphProvider,
} from '../../..';
import {
  MasterAgreementStructure,
  OrderResult,
  OrderStatusResult,
} from '../../../home';
import { IProduct, QuoteResponse } from '../../../product';
import { ApolloProvider } from '../apolloProvider';
import { TravelQueryProvider } from './travelQueryProvider';
import { LegacyOrderResponse } from '../../../../../helpers';
import { validateAddressCommon } from '../commonGraphQLAPI';
import {
  CalculateMultiTripTravelPayload,
  CommonTechnical,
  MultiTripTravel_PolicyDetails,
  OrderMultiTripTravelPayload,
  TriggerEventPayload,
  FeaturesConnection,
  MultiTripTravel_PolicyHolder,
} from './types';
import { gql } from '@apollo/client';
import {
  HomeProduct,
  ProductCommission,
  ProductSupplier,
  ProductSupplierFeature,
  ProductsWithSuppliers,
} from '../../../graphProduct';
import {
  sendEmailToCustomerQuery,
  sendInactivityEmailToCustomerQuery,
  productsWithSuppliersQuery,
  orderMultiTripQueryAffiliate,
  calculateMultiTripQuery,
  calculationInputTravelQuery,
  getFeaturesQuery,
} from '../../queries';
import moment from 'moment';
import { swiftMemberExistsQuery } from '../../queries/swiftMembership';

export class GraphTravelApi extends AbstractComparatorApiService {
  private client;
  private queryProvider: TravelQueryProvider;
  private readonly graphProvider: IGraphProvider;
  constructor(params: IComparatorApiServiceParameters) {
    super(params);
    this.queryProvider = new TravelQueryProvider();
    this.graphProvider = new ApolloProvider(params);
  }

  private generateUUID(): string {
    let d = new Date().getTime(); //Timestamp
    let d2 =
      (typeof performance !== 'undefined' &&
        performance.now &&
        performance.now() * 1000) ||
      0; //Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        let r = self.crypto.getRandomValues(new Uint32Array(1))[0] % 17;
        if (d > 0) {
          //Use timestamp until depleted
          r = (d + r) % 16 | 0;
          d = Math.floor(d / 16);
        } else {
          //Use microseconds since page-load if supported
          r = (d2 + r) % 16 | 0;
          d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
      }
    );
  }

  private getCookie(cookieName): string {
    let cookie = {};
    document.cookie.split(';').forEach((el) => {
      let [key, value] = el.split('=');
      cookie[key.trim()] = value;
    });
    return cookie[cookieName];
  }

  private getAnalyticsSessionIdCookieName = () => {
    const cookieNameStart = document.cookie.substring(
      document.cookie.indexOf('_ga_')
    );
    // for debugging perposes 'GS1.1.1694866573.2.1.1694866579.0.0.0';
    return cookieNameStart.substring(0, cookieNameStart.indexOf('='));
  };

  // private getIdsFromProducts(products: HomeProduct[]): {
  //   parentProductIds: string[];
  //   productIds: string[];
  // } {
  //   let parentProductIds: string[] = [];
  //   let productIds: string[] = [];

  //   for (const product of products) {
  //     if (product.dataProviderKrn.includes('moneyview')) {
  //       if (product.productType === 'insurance/package') {
  //         parentProductIds.push(product.externalId);
  //       } else {
  //         productIds.push(product.externalId);
  //       }
  //     }
  //   }

  //   return {
  //     parentProductIds,
  //     productIds,
  //   };
  // }

  setClient(client) {
    this.client = client;
  }

  getClient() {
    return this.client;
  }

  getComparison(id: string): Promise<Comparison> {
    const cancellation = { 1000: '0', 1500: '1', 2500: '2', 3500: '3' };
    return new Promise<Comparison>((resolve, reject) => {
      const variables = this.queryProvider.calculationInputVariables(id);

      this.graphProvider
        .query<any>(
          gql(calculationInputTravelQuery),
          variables,
          'MultiTripTravelSchema_calculationInput',
          'network-only',
          `${process.env.KIZI_PUBLIC_DOMAIN}/travel/multi-trip/graphql`
        )
        .then(async (data: any) => {
          if (!data.MultiTripTravelSchema_calculationInput) {
            let address;

            try {
              address = await this.validateAddress(
                data.policyPolicyDetails[0].partyPolicyHolders[0].addresses[0]
                  .postalCode,
                data.policyPolicyDetails[0].partyPolicyHolders[0].addresses[0]
                  .houseNumber,
                data.policyPolicyDetails[0].partyPolicyHolders[0].addresses[0]
                  .houseNumberAddition || ''
              );
            } catch (error) {
              console.warn('Address is invalid');
            }

            const criteria = {
              criteria: {
                ...address,
                birthdate: this.getFormatedDate(
                  data.policyPolicyDetails[0].partyPolicyHolders[0].birthDate,
                  'DD-MM-YYYY'
                ),
                postcode:
                  data.policyPolicyDetails[0].partyPolicyHolders[0].addresses[0]
                    .postalCode,
                housenumber:
                  data.policyPolicyDetails[0].partyPolicyHolders[0].addresses[0]
                    .houseNumber,
                houseNumberAddition:
                  data.policyPolicyDetails[0].partyPolicyHolders[0].addresses[0]
                    .houseNumberAddition || '',
                partnerBirthdate: this.getFormatedDate(
                  data.policyPolicyDetails[0].partyPolicyHolders[0]
                    .partyPartners.length > 0
                    ? data.policyPolicyDetails[0].partyPolicyHolders[0]
                        .partyPartners[0].birthDate
                    : '',
                  'DD-MM-YYYY'
                ),
                insuredFamilyComposition: this.getInsuredFamilyCompostion(
                  data.policyPolicyDetails[0].partyPolicyHolders[0]
                ),
                birthdateContextFields: this.getBirthdateContextFields(
                  data.policyPolicyDetails[0].partyPolicyHolders[0]
                ),
                showPriceMode:
                  data.paymentTermInMonths == 12 ? 'year' : 'month',
                numberOfDaysCoverage:
                  data.policyPolicyDetails[0].coverageTravels[0]
                    .numberOfDaysCoverage,
                coverageAreaCode:
                  data.policyPolicyDetails[0].coverageTravels[0]
                    .coverageAreaCode || '',
                medical: data.policyPolicyDetails[0].coverageTravels[0]
                  .costsMedicalTreatmentAdditionallyInsured
                  ? '1'
                  : '-1',
                cancellation:
                  cancellation[
                    data.policyPolicyDetails[0].coverageTravels[0]
                      .insuredAmountTravelCancellation
                  ] || '-1',
                accidents: data.policyPolicyDetails[0].coverageTravels[0]
                  .injuryAdditionallyInsured
                  ? '1'
                  : '-1',
                wintersports: data.policyPolicyDetails[0].coverageTravels[0]
                  .winterSportsAdditionallyInsured
                  ? '1'
                  : '-1',
                underwatersports: data.policyPolicyDetails[0].coverageTravels[0]
                  .underwaterSportsAdditionallyInsured
                  ? '1'
                  : '-1',
                travellegal: data.policyPolicyDetails[0].coverageTravels[0]
                  .legalAidAdditionallyInsured
                  ? '1'
                  : '-1',
                businesstrip: data.policyPolicyDetails[0].coverageTravels[0]
                  .businessTravelAdditionallyInsured
                  ? '1'
                  : '-1',
                transportation: data.policyPolicyDetails[0].coverageTravels[0]
                  .alternativeTransportAdditionallyInsured
                  ? '1'
                  : '-1',
                dangeroussports: data.policyPolicyDetails[0].coverageTravels[0]
                  .dangerousSportsAdditionallyInsured
                  ? '1'
                  : '-1',
                filters: JSON.stringify({
                  showPriceMode:
                    data.paymentTermInMonths == 12 ? ['year'] : ['month'],
                  numberOfDaysCoverage: [],
                  coverageAreaCode: [],
                  medical: [
                    data.policyPolicyDetails[0].coverageTravels[0]
                      .costsMedicalTreatmentAdditionallyInsured
                      ? '1'
                      : '-1',
                  ],
                  cancellation: [
                    cancellation[
                      data.policyPolicyDetails[0].coverageTravels[0]
                        .insuredAmountTravelCancellation
                    ] || '-1',
                  ],
                  accidents: [
                    data.policyPolicyDetails[0].coverageTravels[0]
                      .injuryAdditionallyInsured
                      ? '1'
                      : '-1',
                  ],
                  wintersports: [
                    data.policyPolicyDetails[0].coverageTravels[0]
                      .winterSportsAdditionallyInsured
                      ? '1'
                      : '-1',
                  ],
                  underwatersports: [
                    data.policyPolicyDetails[0].coverageTravels[0]
                      .underwaterSportsAdditionallyInsured
                      ? '1'
                      : '-1',
                  ],
                  travellegal: [
                    data.policyPolicyDetails[0].coverageTravels[0]
                      .legalAidAdditionallyInsured
                      ? '1'
                      : '-1',
                  ],
                  businesstrip: [
                    data.policyPolicyDetails[0].coverageTravels[0]
                      .businessTravelAdditionallyInsured
                      ? '1'
                      : '-1',
                  ],
                  transportation: [
                    data.policyPolicyDetails[0].coverageTravels[0]
                      .alternativeTransportAdditionallyInsured
                      ? '1'
                      : '-1',
                  ],
                  dangeroussports: [
                    data.policyPolicyDetails[0].coverageTravels[0]
                      .dangerousSportsAdditionallyInsured
                      ? '1'
                      : '-1',
                  ],
                  filteropties: [],
                  neOffCostsAmount: [],
                  providerName: [],
                }),
              },
            };

            if (
              data.policyPolicyDetails[0].partyPolicyHolders[0].partyChildren
                .length > 0
            ) {
              criteria.criteria['childBirthdate1'] = this.getFormatedDate(
                data.policyPolicyDetails[0].partyPolicyHolders[0]
                  .partyChildren[0].birthDate || '',
                'DD-MM-YYYY'
              );
            }

            if (
              data.policyPolicyDetails[0].partyPolicyHolders[0].partyChildren
                .length > 1
            ) {
              criteria.criteria['childBirthdate2'] = this.getFormatedDate(
                data.policyPolicyDetails[0].partyPolicyHolders[0]
                  .partyChildren[1]?.birthDate || '',
                'DD-MM-YYYY'
              );
            }

            if (
              data.policyPolicyDetails[0].partyPolicyHolders[0].partyChildren
                .length > 2
            ) {
              criteria.criteria['childBirthdate3'] = this.getFormatedDate(
                data.policyPolicyDetails[0].partyPolicyHolders[0]
                  .partyChildren[2]?.birthDate || '',
                'DD-MM-YYYY'
              );
            }

            if (
              data.policyPolicyDetails[0].partyPolicyHolders[0].partyChildren
                .length > 3
            ) {
              criteria.criteria['childBirthdate4'] = this.getFormatedDate(
                data.policyPolicyDetails[0].partyPolicyHolders[0]
                  .partyChildren[3]?.birthDate || '',
                'DD-MM-YYYY'
              );
            }

            if (
              data.policyPolicyDetails[0].partyPolicyHolders[0].partyChildren
                .length > 4
            ) {
              criteria.criteria['childBirthdate5'] = this.getFormatedDate(
                data.policyPolicyDetails[0].partyPolicyHolders[0]
                  .partyChildren[4]?.birthDate || '',
                'DD-MM-YYYY'
              );
            }

            resolve(criteria);
          } else {
            reject('Incorrect Response!');
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  private getFormatedDate(date: string, format: string): string {
    let retVal = '';

    if (date && date.length > 0) {
      retVal = moment(date).format(format);
    }

    return retVal;
  }

  private getBirthdateContextFields(
    partyPolicyHolder: MultiTripTravel_PolicyHolder
  ): string {
    let retVal: string[] = ['childBirthdate1'];

    if (partyPolicyHolder.partyChildren) {
      let childrenSize = partyPolicyHolder.partyChildren.length;
      for (let i = 1; i < childrenSize; i++) {
        if (partyPolicyHolder.partyChildren[i].birthDate.length > 0) {
          retVal.push('childBirthdate' + (i + 1));
        }
      }
    }

    return JSON.stringify(retVal);
  }

  private getInsuredFamilyCompostion(
    partyPolicyHolder: MultiTripTravel_PolicyHolder
  ): string {
    let retVal = 'VA';

    if (
      partyPolicyHolder.partyChildren &&
      partyPolicyHolder.partyChildren.length > 0
    ) {
      retVal = 'VK';
    }

    if (
      partyPolicyHolder.partyPartners &&
      partyPolicyHolder.partyPartners.length > 0
    ) {
      if (
        partyPolicyHolder.partyChildren &&
        partyPolicyHolder.partyChildren.length > 0
      ) {
        retVal = 'VI';
      } else {
        retVal = 'VH';
      }
    }

    return retVal;
  }

  getCustomerBenefits(): Promise<CustormerBenefitItem[]> {
    throw new Error('Method not implemented.');
  }

  getQuotePrefill(
    accessToken: string,
    swiftUserId: string,
    swiftProductId: string,
    productType: string
  ): Promise<QuoteResponse | false> {
    console.log(swiftUserId, swiftProductId, productType, accessToken);
    throw new Error('Method not implemented');
  }

  validateAddress(
    postcode: string,
    houseNumber: string,
    houseNumberAddition?: string
  ): Promise<AddressApiSuccessResponse> {
    const variables = this.queryProvider.validateAddressVariables(
      postcode,
      parseInt(houseNumber),
      houseNumberAddition
    );

    return validateAddressCommon(this.graphProvider, variables);
  }

  getAddressData(
    postalCode: string,
    houseNumber: string,
    houseNumberAddition?: string
  ): Promise<AddressData> {
    console.log('getAddressData', postalCode, houseNumber, houseNumberAddition);
    throw new Error('Method not implemented.');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getHomeFeaturesDetails(
    productId: number | number[],
    after: string | null
  ): any {
    console.log('getHomeFeaturesDetails', productId, after);
    throw new Error('getHomeFeaturesDetails method not implemented.');
  }

  calculateHomeContentPackage(
    calculateParameters: CalculateParameters
  ): Promise<MasterAgreementStructure> {
    console.log('calculateHomeContentPackage', calculateParameters);
    throw new Error('Method not implemented.');
  }

  async handleFeatures(
    parentProductIds: string[],
    productIds: string[],
    after: string | undefined,
    alreadyLoadedFeatures: FeaturesEdge[] = []
  ): Promise<FeaturesEdge[]> {
    let tempFeatures: FeaturesEdge[] = alreadyLoadedFeatures;

    const featuresQueryVariables = this.queryProvider.featuresVariables(
      parentProductIds,
      productIds,
      after
    );
    return new Promise<FeaturesEdge[]>((resolve, reject) => {
      this.graphProvider
        .query<FeaturesConnection>(
          gql(getFeaturesQuery),
          featuresQueryVariables,
          'features',
          'network-only',
          `${process.env.KIZI_PUBLIC_DOMAIN}/features/graphql`
        )
        .then((feature: FeaturesConnection) => {
          const edges = feature.edges ?? [];
          if (feature.pageInfo.hasNextPage) {
            resolve(
              this.handleFeatures(
                parentProductIds,
                productIds,
                feature.pageInfo.endCursor as string,
                [...tempFeatures, ...edges]
              )
            );
          } else {
            resolve([...tempFeatures, ...edges]);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getProducts(
    searchCriteria: object,
    selectedFilters: object
  ): Promise<IProduct[]> {
    return new Promise<IProduct[]>((resolve, reject) => {
      const multiTripVariables = this.queryProvider.validateMultiTripVariables(
        searchCriteria,
        selectedFilters,
        this.credentials,
        this.generateUUID()
      );

      // let features: FeaturesEdge[] = [];
      let packages: MultiTripTravel_PolicyDetails[] = [];
      let products: HomeProduct[] = [];
      let suppliers: ProductSupplier[] = [];
      let commonTechnical = [{}];
      let productCommissions: ProductCommission[] = [];

      this.graphProvider
        .mutate<CalculateMultiTripTravelPayload>(
          gql(calculateMultiTripQuery),
          multiTripVariables,
          'calculateMultiTripTravel',
          'network-only',
          `${process.env.KIZI_PUBLIC_DOMAIN}/travel/multi-trip/graphql`
        )
        .then((data) => {
          if (
            data.multiTripTravel_CalculationResult &&
            data.multiTripTravel_CalculationResult.policyPolicyDetails
          ) {
            packages =
              data.multiTripTravel_CalculationResult.policyPolicyDetails;
            const result = data.multiTripTravel_CalculationResult;

            if (Array.isArray(result.commonTechnical)) {
              commonTechnical = result.commonTechnical as CommonTechnical[];
            }

            const productsWithSuppliersQueryVars =
              this.queryProvider.validateSuppliersVariables(result);

            this.graphProvider
              .query<ProductsWithSuppliers>(
                gql(productsWithSuppliersQuery),
                productsWithSuppliersQueryVars,
                'productsWithSuppliers',
                'network-only',
                `${process.env.KIZI_PUBLIC_DOMAIN}/product/graphql`
              )
              .then(async (productsWithSuppliers) => {
                products = productsWithSuppliers.products;
                suppliers = productsWithSuppliers.suppliers;
                productCommissions = productsWithSuppliers.productCommission;

                // const { parentProductIds, productIds } =
                //   this.getIdsFromProducts(products);
                // features = await this.handleFeatures(
                //   parentProductIds,
                //   productIds,
                //   undefined
                // );

                const formatted = this.formatTravelProduct(
                  this.credentials,
                  packages,
                  products,
                  suppliers,
                  // features,
                  commonTechnical,
                  productCommissions
                );
                resolve(formatted);
              })
              .catch((error) => {
                reject(error);
              });
          } else {
            reject('No products returned');
          }
        })
        .catch((error) => {
          console.log(error);
          reject('No products returned');
        });
    });
  }

  getRiskConditionDetailsDocuments = (policyPolicyDetails) => {
    const documents = policyPolicyDetails?.conditionConditionDetails?.map(
      (condition) => ({
        label: condition.conditionText,
        urlAttachment: condition.documents[0].urlAttachment,
      })
    );
    return documents ?? null;
  };

  getRiskDocuments = (policyPolicyDetails) => {
    const documents = policyPolicyDetails?.documents?.map((document) => ({
      url: document.urlAttachment,
      label: document.attachmentDescription,
    }));
    return documents ?? null;
  };

  formatTravelProduct(
    credentials: any,
    packages: MultiTripTravel_PolicyDetails[],
    products: HomeProduct[],
    suppliers: ProductSupplier[],
    // featuresEdges: FeaturesEdge[],
    commonTechnical: CommonTechnical[],
    productCommissions: ProductCommission[]
  ): IProduct[] {
    return packages
      .filter((item) => item.totalInstallmentAmount !== null)
      .map((policyDetails) => {
        const {
          customProperties,
          productCode,
          productDescription,
          totalInstallmentAmount,
          oneOffCostsAmount,
          coverageTravels,
          expectedAcquisitionCommissionPartnerAmount,
          underwritingCompanySpecifics,
        } = policyDetails;

        const product: HomeProduct = {
          ...basicHomeProduct,
          ...products.find((p) => p.krn === productCode),
        };
        const supplier: ProductSupplier = {
          ...basicHomeSupplier,
          ...suppliers.find((s) => s.krn === customProperties?.supplierKrn),
        };
        // const productId = parseInt(product.externalId);
        // const ownFeatures = featuresEdges.filter((feature) => {
        //   return [
        //     feature.node.parentProductId,
        //     feature.node.productId,
        //   ].includes(productId);
        // });

        const productCommission = {
          ...{
            krn: '',
            renewalCommissionInstallmentAmountPartner: null,
            commissionConfigs: [
              {
                renewalCommissionInstallmentNumberOfMonths: null,
                renewalCommissionInstallmentAmountLink: null,
              },
            ],
          },
          ...productCommissions.find((p) => p.krn === product.krn),
        };

        const {
          affiliateUrl,
          customAttributes,
          dataProviderKrn,
          insuranceCardUrl,
          name: productName,
          orderType,
          productType,
          termsAndConditionsUrl,
          testScores,
        } = product;

        const productSellingPoints = product?.sellingPoints?.map((el) => ({
          ...el,
          orderType,
        }));

        const {
          about,
          advantages,
          disadvantages,
          features,
          howItWorks,
          name,
          nameLogoUrl,
          sellingPoints,
          sustainabilityScore,
          taskDivisions,
        } = supplier;

        let visibleAffiliateUrl = '';

        if (orderType === 'AFFILIATE') {
          visibleAffiliateUrl = affiliateUrl;
        }
        const renewalCommissionInstallmentAmountPartner =
          productCommission?.renewalCommissionInstallmentAmountPartner;

        try {
          const formatted: any = {
            ...basicHomeIProduct,
            affiliateUrl: visibleAffiliateUrl,
            commonTechnical: [
              {
                senderId: credentials.clientId,
                sessionId: '',
                transactionReference:
                  commonTechnical[0].transactionReference || '',
              },
            ],
            bigProductFeature: {
              ...basicHomeIProduct.bigProductFeature,
              decimals: 0,
              label: 'Eigen risico',
              hideIfZero: false,
              variant: 'priceMedium',
              value: {
                month: coverageTravels?.[0].deductibleAmount || '0',
                year: coverageTravels?.[0].deductibleAmount || '0',
              },
            },
            characteristics: this.buildCharacteristics(features || []),
            coverageTravels: coverageTravels?.[0],
            customAttributes,
            // fees: ownFeatures.map(({ node }) => {
            //   return {
            //     category: node.category,
            //     label: node.name,
            //     value: node.data,
            //   };
            // }),
            id: `${productCode}`,
            image: nameLogoUrl,
            orderType,
            priceInfo: {
              ...basicHomeIProduct.priceInfo,
              initial: totalInstallmentAmount,
              total: totalInstallmentAmount,
            },
            productCode: productCode || '',
            productType: productType || '',
            termsAndConditionsUrl,
            testScores,
            prosAndCons: {
              cons: {
                ...basicHomeIProduct.prosAndCons.cons,
                title1: disadvantages?.[0]?.description || '',
                title2: disadvantages?.[1]?.description || '',
              },
              pros: {
                ...basicHomeIProduct.prosAndCons.cons,
                title1: advantages?.[0]?.description || '',
                title2: advantages?.[1]?.description || '',
              },
            },
            provider: {
              ...basicHomeIProduct.provider,
              description: about,
              howItWorks,
              insuranceCardUrl,
              label: name + ' ' + productDescription,
              name,
              sellingPoints,
              sustainabilityScore: sustainabilityScore
                ? `${sustainabilityScore[0]?.score}`
                : '',
              taskDivisions,
              termsAndConditionsUrl,
              id: supplier.krn,
              ...(dataProviderKrn === 'krn:kizi:data-provider:risk'
                ? {
                  coverageConditions: this.getRiskConditionDetailsDocuments(
                    policyDetails ?? {}
                  ),
                  documents: this.getRiskDocuments(policyDetails ?? {}),
                }
                : {}),
              type: dataProviderKrn,
            },
            purchasableProduct:
              orderType !== 'NOT_ORDERABLE' &&
              underwritingCompanySpecifics !== null &&
              underwritingCompanySpecifics !== undefined &&
              underwritingCompanySpecifics[0].underwritingResult === 'V1',
            testScore: testScores?.[0]?.score || 0,
            usps: getUspsBySellingPointsByOrderType(
              productSellingPoints || sellingPoints,
              orderType
            ),
            totalInstallmentAmount,
            oneOffCostsAmount,
            productDescription,
            expectedAcquisitionCommissionPartnerAmount,
            type: 'travel',
            subscriptionName: productName || '',
            commissionTransparency: {
              renewalCommissionInstallmentAmountPartner:
                renewalCommissionInstallmentAmountPartner != null
                  ? renewalCommissionInstallmentAmountPartner
                    .toFixed(2)
                    .replace('.', ',')
                  : null,
              renewalCommissionInstallmentNumberOfMonths:
              productCommission?.commissionConfigs?.[0]
                ?.renewalCommissionInstallmentNumberOfMonths,
              renewalCommissionInstallmentAmountLink:
              productCommission?.commissionConfigs?.[0]
                ?.renewalCommissionInstallmentAmountLink,
            },
          };
          return formatted;
        } catch (e) {
          console.log(e);
          return {};
        }

      });
  }

  buildCharacteristics = (features: ProductSupplierFeature[]) =>
    features
      ? features.map((feature) => {
          return {
            label: feature.name,
            value: feature.value,
          };
        })
      : [];

  async orderAffiliateContentPackage(
    transactionReference: string,
    productCode: string
  ): Promise<OrderResult> {
    const variables = this.queryProvider.orderMultiTripVariables(
      transactionReference,
      productCode,
      this.generateUUID(),
      this.credentials.clientId ?? ''
    );
    const query = orderMultiTripQueryAffiliate;

    return new Promise<OrderResult>((resolve, reject) => {
      this.graphProvider
        .mutate<OrderMultiTripTravelPayload>(
          query,
          {
            ...variables,
            request: {
              commonTechnical: {
                googleAnalyticsId: this.getCookie('_ga'),
                googleAnalyticsSessionId: this.getCookie(
                  this.getAnalyticsSessionIdCookieName()
                ),
                senderId: this.credentials.clientId,
              },
            },
          },
          'orderMultiTripTravel'
        )
        .then((data: OrderMultiTripTravelPayload) => {
          resolve({
            orderId: data.multiTripTravel_OrderResult?.orderId,
            errors: [],
          });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  sendEmailToCustomer(
    comparisonId: string | number,
    email: string,
    productType: string,
    inactivity: boolean
  ): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const variables = this.queryProvider.validateEmailVariables(
        comparisonId,
        email,
        productType
      );

      const query = inactivity
        ? sendInactivityEmailToCustomerQuery
        : sendEmailToCustomerQuery;

      this.graphProvider
        .mutate<TriggerEventPayload>(
          gql(query),
          variables,
          'triggerEvent',
          'network-only',
          `${process.env.KIZI_PUBLIC_DOMAIN}/events/graphql`
        )
        .then((data: TriggerEventPayload) => {
          if (data.success) {
            resolve('Email sent successfully');
          } else {
            reject('Email could not be sent');
          }
        })
        .catch((err) => {
          console.error(err);
          reject('Email could not be sent');
        });
    });
  }

  getCalculationInput(
    transactionReference: string
  ): Promise<MasterAgreementStructure> {
    console.log('getCalculationInput', transactionReference);
    throw new Error('Method not implemented.');
  }

  orderStatus(orderId: string): Promise<OrderStatusResult> {
    console.log('orderStatus', orderId);
    throw new Error('Method not implemented.');
  }

  getOrderDefinition(
    product: IProduct,
    productType: 'cars' | 'energy' | 'energyAuction'
  ): Promise<LegacyOrderResponse['data']> {
    console.log('getOrderDefinition', product, productType);
    throw new Error('Method not implemented.');
  }

  checkMembershipStatus(email): Promise<boolean> {
    return new Promise(((resolve, reject) => {
      const query = swiftMemberExistsQuery;
      const graphURL = `${process.env.KIZI_PUBLIC_DOMAIN}/shared/services/graphql?sdl=true`;

      const variables = {
        swiftMemberCheck: {
          email
        },
        correlationId: `membership-check-${Date.now()}`
      };
      this.graphProvider
        .mutate<any>(
          gql(query),
          variables,
          'swiftMemberExists',
          'network-only',
          graphURL
        ).then((res) => {
        resolve(res.exists);
      }).catch((error) => {
        reject(error);
      });
    }));
  }
}
